import { withTranslation } from 'react-i18next';
import { PureComponent } from 'react';
import { Segment } from 'semantic-ui-react';
import { map } from '../../../utils/lodash';
import './activity.scss';

class ActualInput extends PureComponent {
  render() {
    const { t } = this.props;

    return (
      <Segment className="report-activity-seg">
        <div className="report-activity-div">
          <div className="row">
            {/*<div className="col-lg-5">
              <label className="info-title">ACTUAL EXPENDITURE</label>
              <p className="info-desc">
                ${this.props.cost ? this.props.cost : '-'}
              </p>
            </div> */}
            <div className="col-lg-5">
              <label className="info-title">
                {t('activity.activity_plan.actual_input.total_volunteers')}
              </label>
              <p className="info-desc">
                {this.props.volunteers ? this.props.volunteers : '-'}
              </p>
            </div>
            <div className="col-lg-5">
              {/* <label className="info-title">TOTAL CREATIVE PRACTITIONERS</label>
                  <p className="info-desc">
                    {this.props.practitioners ? this.props.practitioners : '-'}
                  </p> */}
            </div>
            {/*<div className="col-lg-5">
              <label className="info-title">VALUE OF CONTRACTORS</label>
              <p className="info-desc">${this.getValue()}</p>
            </div> */}
            <div className="col-lg-5">
              <label className="info-title">
                {t('activity.activity_plan.actual_input.venues')}
              </label>
              {this.getVenues()}
            </div>
            {/* <div className="col-lg-5">
              <label className="info-title">CONTRACTOR(s)</label>
              {this.getContractors()}
            </div> */}
          </div>
        </div>
      </Segment>
    );
  }

  getValue() {
    let value = 0;
    let values = this.props.value;
    values.forEach((element) => {
      if (element.cost != null && element.cost !== '' && !isNaN(element.cost)) {
        value += parseInt(element.cost);
      }
    });
    return value;
  }

  getVenues() {
    return map(this.props.venue, (item, index) => (
      <p className="info-desc info-desc-last" key={index}>
        {item.name}
      </p>
    ));
  }

  getContractors() {
    return map(this.props.value, (item, index) => (
      <p className="info-desc info-desc-last" key={index}>
        {item.name}
      </p>
    ));
  }
}

ActualInput = withTranslation()(ActualInput);

export { ActualInput };
